class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartIsOpen = false;
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    document.addEventListener('header-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('menu-drawer:opened', this.onDrawerOpened.bind(this));
    document.addEventListener('modal-dialog:opened', this.onDrawerOpened.bind(this));

    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.mediaQuery.addEventListener('change', this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(this.mediaQuery);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');

    const enableCartDrawer = cartLink.getAttribute('data-enable-drawer') === 'true';
    if (!enableCartDrawer) return;

    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.contains('active') ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.classList.contains('active') ? this.close() : this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this.cartIsOpen = true;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('#Details-CartDrawer-Note summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');

      const event = new CustomEvent('cart-drawer:opened', { bubbles: true, detail: { elementToFocus: triggeredBy } });
      document.dispatchEvent(event);

      this.setHeaderBottomPosition();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.header.classList.remove('show-faux-search-bar');
  }

  close() {
    if (!this.cartIsOpen) {
      return;
    }
    this.cartIsOpen = false;
    const activeModals = document.querySelectorAll(
      '.drawer-modal[open], .drawer.active, .menu-drawer-container[open], menu-drawer > [open]'
    );

    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    // Listen for the transitionend event to remove the overflow-hidden class
    this.addEventListener(
      'transitionend',
      () => {
        if (activeModals.length <= 1) {
          document.body.classList.remove('overflow-hidden');
        }
      },
      { once: true }
    );
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setHeaderBottomPosition() {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.header.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
  }

  onMediaQueryChange(event) {
    if (event.matches) {
      this.setHeaderBottomPosition();
    } else {
      this.setHeaderBottomPosition();
    }
  }

  onDrawerOpened(evt) {
    const { elementToFocus } = evt.detail;
    this.close(evt, elementToFocus);
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
